import { render, staticRenderFns } from "./ModalCreateConcept.vue?vue&type=template&id=0506bd1b"
import script from "./ModalCreateConcept.vue?vue&type=script&lang=js"
export * from "./ModalCreateConcept.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateConcept.vue?vue&type=style&index=0&id=0506bd1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports